<script>
  export let message, logoUrl;
</script>

<footer>

	<div class='container'>
		<div class='row'>

				<div class='col-12' style='text-align:center'>
					<img alt='logo' style='display: block; margin: auto; max-width: 150px;' class='mb-4' src={logoUrl}/>
					<p>{message}</p>
				</div>

		</div>
	</div>
</footer>

<style>
  footer {
    color: #333;
  }
  footer p {
    line-height: 1.1;
    color: #333;
    font-size: 12px;
    text-align: center;
  }
</style>
